import React, { Component } from "react";
import Home from "./Components/Home/Home";
import Navbar from "./Components/Navbar/Navbar";
import Portfolio from "./Components/Portfolio/Portfolio";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Modal from "./Components/Modal/Modal";

export default class App extends Component {
  render() {
    return (
      <>
        <Navbar />
        <Home />
        <Portfolio />
        <About />
        <Contact />
        <Footer />
        <Modal/>
      </>
    );
  }
}
